// extracted by mini-css-extract-plugin
export default {"Text":"BackOfficeUserInformation_Text__Zw55b","Layout":"BackOfficeUserInformation_Layout__TrJIx","Column":"BackOfficeUserInformation_Column__nt-pr"};